// extracted by mini-css-extract-plugin
module.exports = {"MainImage":"MainImage_MainImage__18Pz4"};